import { Wait } from "@/features/wait";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/wait")({
  component: Wait,
});
